module.exports = __webpack_public_path__ + "static/img/headerImg.35e03830.png";